module.exports = __webpack_public_path__ + "img/friends-dintica-sm.e305ca0c.png";